import { BaseOrder } from './BaseOrder';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getActivity(obj) {
    try {
      await checkLicenseExpiry();
      const data = await req.get('activity', {
        params: obj,
      });
      return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      return { data: [], totalCount: 0 };
    }
  },
  async getrecentEvents(httpOptions = {}) {
    try {
      httpOptions.params = { source: 'Landing', ...httpOptions.params || {} };
      const activityData = await req.get('activity', httpOptions);
      activityData.data.data.forEach((act) => {
        if (!act.shippingLabel) {
          const module = act.module.charAt(0).toLowerCase() + act.module.slice(1);
          if (act.module === 'MaterialManager' && act.sourcingOrder) {
            act.sourcingOrder.project = act.project;
            act.order = new BaseOrder(act.sourcingOrder);
          } else {
            if (act[module]) act[module].project = act.project;
            act.order = new BaseOrder(act[module]);
          }
        } else {
          act.order = act.shippingLabel;
        }
      });
      return {
        data: activityData.data.data,
        total: activityData.data.totalCount,
        page: activityData.data.page,
      };
    } catch (error) {
      console.error(`Error: ${error.message}`);
      return {
        data: [],
        total: 0,
        page: 1,
      };
    }
  },
  async getWeeksActivity(obj) {
    try {
      await checkLicenseExpiry();
      const data = await req.get('weeksActivity', {
        params: obj,
      });
      return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      return { data: [], totalCount: 0 };
    }
  },
};
